// ToastRoot is not default export
import { ToastRoot as OrbitsToastRoot } from '@kiwicom/orbit-components/lib/Toast'; // eslint-disable-line

const ToastRoot = () => <OrbitsToastRoot placement="top-center" topOffset={80} />;

export default ToastRoot;
